import React from 'react'
import Icon from 'react-icon-base'

const StarOutlineIcon = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m20 25.7l6.3 3.8-1.7-7.2 5.6-4.8-7.4-0.6-2.8-6.7-2.8 6.7-7.4 0.6 5.6 4.8-1.6 7.2z m16.6-10.3l-9 7.9 2.7 11.7-10.3-6.2-10.3 6.2 2.7-11.7-9-7.9 11.9-1 4.7-11 4.7 11z" />
    </g>
  </Icon>
)

export default StarOutlineIcon
